module.exports = __webpack_public_path__ + "img/structure-management-2025.fea89184.jpg";